import React from "react";

export type PositionsTab = "actual" | "target" | "combined";

const TAB_OPTIONS: { id: PositionsTab; label: string }[] = [
  { id: "combined", label: "Combined" },
  { id: "actual", label: "Actual" },
  { id: "target", label: "Target" },
];

export interface PositionsTabToggleProps {
  activeTab: PositionsTab;
  onTabChange: (tab: PositionsTab) => void;
}

const PositionsTabToggle: React.FC<PositionsTabToggleProps> = ({
  activeTab,
  onTabChange,
}) => {
  const count = TAB_OPTIONS.length;
  const activeIdx = TAB_OPTIONS.findIndex((t) => t.id === activeTab);
  const pct = 100 / count;
  return (
    <div className="relative inline-flex items-center rounded-lg border border-gray-200 dark:border-rp-separator bg-gray-50 dark:bg-black/30 p-0.5">
      <div
        className="absolute top-0.5 bottom-0.5 rounded-md bg-rp-amber transition-all duration-300 ease-in-out"
        style={{
          width: `calc(${pct}% - 4px)`,
          left: `calc(${pct * activeIdx}% + 2px)`,
        }}
      />
      {TAB_OPTIONS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`relative z-10 w-[72px] sm:w-[100px] py-1.5 text-xs font-medium text-center rounded-md transition-colors duration-300 ${
            activeTab === tab.id
              ? "text-white"
              : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PositionsTabToggle;
